"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WebContractListAddressesResponseSchema = exports.WebContractGetAddressResponseSchema = exports.WebContractAddressIdPathParamsSchema = exports.WebContractListAddressesQueryParamsSchema = exports.WebContractUpdateAddressRequestSchema = exports.WebContractCreateAddressRequestSchema = void 0;
const zod_1 = require("zod");
const shared_1 = require("../../../shared");
const AddressSchema = zod_1.z.object({
    id: zod_1.z.string().uuid(),
    createdAt: zod_1.z.coerce.date(),
    updatedAt: zod_1.z.coerce.date(),
    label: zod_1.z.string(),
    address: zod_1.z.string(),
    address2: zod_1.z.string().nullable(),
    district: zod_1.z.string(),
    province: zod_1.z.string(),
    postalCode: zod_1.z.string(),
    recipientName: zod_1.z.string(),
    recipientPhoneNumber: zod_1.z.string(),
    isDefaultShipping: zod_1.z.boolean(),
    isDefaultBilling: zod_1.z.boolean(),
    userId: zod_1.z.string(),
    countryCode: zod_1.z.string(),
});
exports.WebContractCreateAddressRequestSchema = AddressSchema.pick({
    label: true,
    recipientName: true,
    recipientPhoneNumber: true,
    address: true,
    address2: true,
    district: true,
    province: true,
    countryCode: true,
    postalCode: true,
    isDefaultShipping: true,
    isDefaultBilling: true,
});
exports.WebContractUpdateAddressRequestSchema = exports.WebContractCreateAddressRequestSchema;
exports.WebContractListAddressesQueryParamsSchema = shared_1.ContractPaginationQueryParamsSchema;
exports.WebContractAddressIdPathParamsSchema = zod_1.z.object({ addressId: shared_1.UUIDSchema });
const WebContractAddressSchema = AddressSchema.omit({
    userId: true,
    createdAt: true,
    updatedAt: true,
}).extend({
    createdAt: zod_1.z.string(),
    updatedAt: zod_1.z.string(),
    countryName: zod_1.z.string(),
});
exports.WebContractGetAddressResponseSchema = zod_1.z.object({ address: WebContractAddressSchema });
exports.WebContractListAddressesResponseSchema = shared_1.ContractBaseListResponseSchema.extend({ addresses: WebContractAddressSchema.array() });
